import React, { useState } from 'react';
import HomeFooter from "../Footer/HomeFooter";
import MerakiHomeBody from '../../pages/MerakiHomeBody';
import AuthenticatedHomeHead from '../Header/AuthenticatedHomeHead';
import Profile from './Profile';
import OTPPage from './OTPPage';

const MerakiHome = () => {
  const [showComponents, setShowComponents] = useState(false);

  const handleJoinUsClick = () => {
    setShowComponents(true);
  }
  return (
    <html lang="en">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta http-equiv="X-UA-Compatible" content="ie=edge" />
        <meta name="forntEnd-Developer" content="Saad & Muzammil" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>GameNow</title>
        <link rel="shortcut icon" href="assets/images/favicon.png" type="image/x-icon" />
        <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
        <link rel="stylesheet" href="assets/css/plugin.css" />
        <link rel="stylesheet" href="assets/css/style.css" />
        <link rel="stylesheet" href="assets/css/responsive.css" /> 
      </head>
      <body>
        <AuthenticatedHomeHead onJoinUsClick={handleJoinUsClick} />
        <MerakiHomeBody/>
        <HomeFooter />
        {showComponents && <Profile />}
        {showComponents && <OTPPage />}

      </body>
    </html>
  );
};

export default MerakiHome;
